import React from 'react'
import './M_ElementDrawer.css'
import { SwipeableDrawer, Tooltip, useMediaQuery } from '@mui/material'
import { DragHandle } from '@mui/icons-material'
import { useResize, MButton } from '../../M_Components'
import PropTypes from 'prop-types'

export const MElementDrawer = ({ open, setOpen, onClose, element, toolTipClose }) => {
    const { width, enableResize } = useResize(400)
    const match = useMediaQuery('(max-width: 900px)')
    const mobileWidth = useMediaQuery('(min-width:500px)')

    const closeDrawer = () => {
        onClose()
        setOpen(false)
    }

    const toggleDrawer = () => {
        setOpen(true)
    }

    return (
        <SwipeableDrawer
            data-testid="drawer"
            className="M_swipeableDrawer"
            anchor={'right'}
            open={open}
            onClose={() => closeDrawer()}
            onOpen={() => toggleDrawer()}
            PaperProps={{
                style: {
                    minWidth: !mobileWidth ? '100vw' : (match ? 'auto' : '900px'),
                    width, maxWidth: '1400px'
                }
            }}
        >
            <Tooltip title={toolTipClose || ""}>
                <div style={{ display: 'flex', justifyContent: 'left', marginLeft: '5px', width: 'max-content' }}>
                    <MButton
                        none
                        icon={<i className="pi pi-times " />}
                        onClick={() => closeDrawer()}
                    />
                </div>
            </Tooltip>
            <div id='dragger' className='M_divDragger' data-testid="dragger">
                <div className='M_divInteriorDragger'>
                    <DragHandle className='M_dragHandleIcon' onMouseDown={(e) => {
                        enableResize(e)
                    }} />
                </div>
            </div>
            <div style={{ zIndex: '1202', marginLeft: '10px', height: '100%', overflow: 'auto' }}>
                {open && element}
            </div>
        </SwipeableDrawer>
    )
}

MElementDrawer.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    onClose: PropTypes.func,
    element: PropTypes.element,
    toolTipClose: PropTypes.string
}